'use client'

import { useAnalyticsPageView } from 'hooks/analytics/useAnalyticsPageView'

export function useAnalytics() {
  useAnalyticsPageView()
}
